import React, { useEffect, useRef, useState } from "react";
import "./form.css";
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import { firestore, storage } from "../config/firebase";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import {
  collection,
  getDocs,
  getDoc,
  setDoc,
  doc,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import {
  Box,
  Grid,
  TextField,
  Button as MuiButton,
  Typography,
  FormHelperText,
  Paper,
  Divider,
  Avatar,
  IconButton,
  Tooltip,
} from "@mui/material";
import Modal from "antd/es/modal/Modal";
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { deepPurple } from '@mui/material/colors';
import { debounce, throttle } from "lodash";
import { emailRegex, generateUuid, regexPattern } from "../utils/constants";
import stateName from '../jsonData/state-list.json'

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  state: "",
  city: "",
  dateJoined: "",
};

const UserForm = ({ toggleModal, refreshList, isModalVisible }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    state: "",
    city: "",
    purpose: "Study",
  });
  const purpose = [
    { value: "Study", label: "Study" },
    { value: "Job", label: "Job" },
    { value: "Travel", label: "Travel" },
  ];
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [stateCode, setStateCode] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [errors, setErrors] = useState({});
  const fileInputRef = useRef(null);

  // Custom styles for react-select to fix transparent backgrounds
  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#fff',
      borderColor: state.isFocused ? '#1976d2' : provided.borderColor,
      boxShadow: state.isFocused ? '0 0 0 2px #1976d233' : provided.boxShadow,
      minHeight: 40,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#fff',
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#e3f2fd' : state.isFocused ? '#f1f1f1' : '#fff',
      color: '#222',
    }),
  };

  const handleValidation = () => {
    const newErrors = {};
    if (!formData.firstName || formData.firstName === "")
      newErrors.fName = "First name is required";
    else if (formData.firstName.length < 3 || formData.firstName.length > 50)
      newErrors.fName = "First name must be 3 to 50 characters long";

    if (!formData.lastName || formData.lastName === "")
      newErrors.lName = "Last name is required";
    else if (formData.lastName.length < 3 || formData.lastName.length > 50)
      newErrors.lName = "Last name must be 3 to 50 characters long";

    if (!formData.email || formData.email === "")
      newErrors.email = "Email is required";
    if (!formData.phone || formData.phone === "")
      newErrors.phone = "Phone number is required";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Enter a valid email address";

    if (!formData.city || formData.city == "") newErrors.city = "Select city";
    if (!formData.state || formData.state == "")
      newErrors.state = "Select state";

    setErrors(newErrors);

    return Object.keys(newErrors).length == 0;
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timeoutId = setTimeout(() => {
        setErrors({});
      }, 5000);
      return () => clearTimeout(timeoutId);
    }
  }, [errors]);

  const handleOnChange = (e) => {
    if (regexPattern.test(e.target.value)) {
      if (e.target.name === "firstName") {
        setFormData({ ...formData, firstName: e.target.value });
      } else setFormData({ ...formData, lastName: e.target.value });
    }
  };
  const handlePhoneNumberChange = (e) => {
    if (e.target.value.length < 11) {
      const cleanedText = e.target.value.replace(/[^0-9]/g, "");
      setFormData({ ...formData, phone: cleanedText });
    }
  };

  useEffect(() => {
    if (!stateList.length) {
      setStateList([
        ...State.getStatesOfCountry("IN").map((el, index) => {
          return { value: el.isoCode, label: el.name };
        }),
      ]);
    }
  }, []);

  useEffect(() => {
    if (stateCode) {
      setCityList([
        ...City.getCitiesOfState("IN", stateCode).map((el) => {
          return { label: el.name };
        }),
      ]);
    }
  }, [stateCode]);

  const handleAddCounsellor = async () => {
    const newErrors = {};
    let flag = handleValidation();
    let Uid = generateUuid(formData.firstName);
    if (flag) {
      try {
        const querySnapshot = await getDocs(collection(firestore, "users"));

        let result = querySnapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter(
            (res) => res.email === formData.email || res.phone == formData.phone
          );
        if (result.length) {
          if (result[0].email === formData.email) {
            newErrors.email = "Email already registered";
          }
          if (result[0].phone === formData.phone) {
            newErrors.phone = "Phone number already registered";
          }
          setErrors(newErrors);
          return;
        }
        let userData = {
          state:formData.state,
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          country: "India",
          city: formData.city,
          isActive: true,
          purpose: formData.purpose,
          isBlocked: false,
          isDeleted: false,
          image: selectedImage || "",
          phone: formData.phone,
          uuid: Uid,
          fcm: "",
          access_token: "",
          receiverUid: "",
          status: false,
        };
        let userAttribute = {
          allotedTime: 0,
          balance: 0,
          associatedWith: "",
          counsellorImage: "",
          counsellorName: "",
          counsellor_uuid: "",
          feedback: false,
          start_time: 0,
          type: "",
        };
        let resetState = {
          warning: false,
          reset: false,
        };

        const userRef = doc(firestore, "users", formData.phone);
        const fcmRef = doc(firestore, "fcm_token",Uid);
        const userRefState = doc(firestore, "reset_state", Uid);
        const userRefAttribute = doc(firestore, "user_attribute", Uid);
        await getDoc(userRef);
        await setDoc(fcmRef,{fcm:"demo"});
        await setDoc(userRef, userData);
        await setDoc(userRefAttribute, userAttribute);
        await setDoc(userRefState, resetState);
        setFormData(initialState);
        toggleModal();
        refreshList();
      } catch (error) {
        console.error("Error adding new counsellor:", error);
      }
    }
  };

  const handleEditIconClick = (e) => {
    e.stopPropagation();
    fileInputRef.current.click();
  };
  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    let err = {};
    let ext = selectedFile.name;
    ext = ext.split(".");
    if (ext[1] === "svg") {
      err.image = "SVG images are not allowed";
      setErrors(err);
      return;
    } else {
      setErrors({});
    }
    if (selectedFile) {
      const uniqueFilename = `${Date.now()}-${uuidv4()}`;
      const storageRef = ref(storage, `user_images/${uniqueFilename}`);
      uploadBytes(storageRef, selectedFile)
        .then((snapshot) => getDownloadURL(snapshot.ref))
        .then((downloadURL) => {
          setSelectedImage(downloadURL);
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const resetStates = async () => {
    if (selectedImage) {
      const oldImageRef = ref(storage, selectedImage);

      try {
        await deleteObject(oldImageRef);
        setFormData(initialState);
        setSelectedImage("");
      } catch (err) {
        console.log("Cannot delete image==========", err);
      }
    }
    setFormData(initialState);
    setErrors({});
    setStateCode("");
    setCityList([]);
    toggleModal();
  };

  return (
    <Modal
      title={null}
      open={isModalVisible}
      onCancel={() => {
        resetStates();
      }}
      footer={null}
      centered
      style={{ padding: 0 }}
    >
      <Paper elevation={4} sx={{ p: 4, borderRadius: 3, maxWidth: 650, mx: 'auto', my: 2 }}>
        <Typography variant="h5" align="center" sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}>
          Add New User
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              position: "relative",
              mb: 1,
              '&:hover .avatar-overlay': { opacity: 1 },
              cursor: 'pointer',
            }}
            onClick={handleEditIconClick}
          >
            <Avatar
              sx={{ width: 80, height: 80, bgcolor: deepPurple[800], fontSize: 36 }}
              src={selectedImage}
              alt="Selected"
            >
              {!selectedImage && <PhotoCamera fontSize="large" />}
            </Avatar>
            <Box
              className="avatar-overlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                bgcolor: 'rgba(33,150,243,0.65)',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                opacity: 0,
                transition: 'opacity 0.3s',
                zIndex: 2,
              }}
            >
              <Tooltip title="Change Image">
                <IconButton color="inherit" component="span" size="large">
                  <AddAPhotoIcon fontSize="large" />
                </IconButton>
              </Tooltip>
            </Box>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileInputChange}
            />
          </Box>
          {errors.image && <FormHelperText error>{errors.image}</FormHelperText>}
        </Box>
        <Box component="form" sx={{ width: "100%", mt: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleOnChange}
                error={!!errors.fName}
                helperText={errors.fName}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleOnChange}
                error={!!errors.lName}
                helperText={errors.lName}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                error={!!errors.email}
                helperText={errors.email}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handlePhoneNumberChange}
                error={!!errors.phone}
                helperText={errors.phone}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Purpose</Typography>
                <Select
                  onChange={async (a) => {
                    setFormData({ ...formData, purpose: a.label });
                  }}
                  options={purpose}
                  placeholder="Select Purpose"
                  styles={selectStyles}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>State</Typography>
                <Select
                  onChange={async (a) => {
                    setStateCode(a.value);
                    setFormData({ ...formData, state: a.label });
                  }}
                  options={stateList}
                  placeholder="Select state"
                  styles={selectStyles}
                />
                {errors.state && <FormHelperText error>{errors.state}</FormHelperText>}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              {cityList.length ? (
                <Box>
                  <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>City</Typography>
                  <Select
                    onChange={async (a) => {
                      setFormData({ ...formData, city: a.label });
                    }}
                    options={cityList}
                    placeholder="Select city"
                    styles={selectStyles}
                  />
                  {errors.city && <FormHelperText error>{errors.city}</FormHelperText>}
                </Box>
              ) : null}
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center", mt: 3 }}>
              <MuiButton
                variant="contained"
                color="primary"
                size="large"
                sx={{ px: 6, py: 1.5, fontWeight: 600, borderRadius: 2, boxShadow: 2, letterSpacing: 1 }}
                onClick={handleAddCounsellor}
              >
                Submit
              </MuiButton>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Modal>
  );
};

export default UserForm;
